module.exports = __webpack_public_path__ + "img/Icon awesome-file-download.135d97bd.svg";